import {Http, Headers} from '@angular/http'
import {Injectable} from '@angular/core';
import {IConfig} from './iconfig';
import {Usuario, Logon} from '../lib/model';
import Modo from '../enums/modo';

@Injectable()
export class ConfigService {

    public static URLAPI: string = 'https://seguro.fisistemas.com.br/otgdmapi/api/';
    //public static URLAPI: string = 'http://localhost:36436/api/';
    // public static URLAPI: string = 'http://192.168.1.98/GDM-API/api/';

    configuracao: IConfig = {
        UrlApi: 'http://localhost:56654/api/',
        usuario: null,
        modo: null
    }

    load() {
        return localStorage.getItem('modo');
    }

    constructor(private _http: Http) {
        this.configuracao.modo = this.load();
    }

    // metodos auxiliares
    getJsonHeaders(token?: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'q=0.8;application/json;q=0.9');

        if (token){
            headers.append('Authorization', token);
        }
        
        return { headers: headers };
    }    
    
} 



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/config/config.service.ts
 **/